export function deviceSettingsRender() { return `<div id="device-settings-container">
    <div class="device-settings-container">
        <div>
            <h3>${ this.headingText }</h3> 
        </div>
        ${ !this.saveAndContinueNext ? `<div class="device-media-container">
            <p class="device-setting-tips">
                ${ this.primaryText }
            </p>
            <p class="browser-tips">
                ${ this.secondaryText }
            </p>
            <div class="preview-container">
                ${ this.showCustomerCamera ? `<div class="camera-preview-lable">Preview</div>`:`` }
            </div>
            <div class="device-media-source">
                ${ this.showCustomerCamera ? `<div>
                    <label for="videoSource">Camera </label>
                    <select id="videoSource"></select>
                </div>`:`` }
                
                <div>
                    <label for="audioSource">Microphone </label>
                    <select id="audioSource"></select>
                    <div class="microphone-volume-container">
                        <img src="${ this.microphoneVolumeImg }">
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                        <div class="microphone-volume-level"></div>
                    </div>
                </div>
            
                <div>
                    <label for="audioOutput">Speaker</label>
                    <select id="audioOutput"></select>
                    <div class="speaker-volume-container">
                        <img src="${ this.speakerMuteImg }" role="button" ld--elist="click" ld-on-click="muteVolume">
                        <input id="vol-control" class="volume-range" type="range" min="0" max="100" step="1" ld--elist="change,input" ld-on-change="setVolume" ld-on-input="setVolume">
                        <img src="${ this.speakerVolumeImg }" ld--elist="click" ld-on-click="unmuteVolume">
                    </div>
                    
                </div>
            </div>
        </div>`:`` }
        ${ this.saveAndContinueNext ? `<div>
            <div>
                <p class="device-setting-tips">
                   ${ this.finalText }
                </p>
                <p class="browser-tips">
                    ${ this.disclaimerText }
                </p>
            </div>    
            <div class="pre-call-instructions-footer">
                <button id="getStartedBtn" class="pre-call-instructions-footer-button">
                    ${ this.showCustomerCamera ? `<i class="fa fa-camera"></i>`
                    :`<i class="fa fa-microphone"></i>` }
                    ${ this.startButtonText }
                </button>
            </div>
        </div>`:`` }
    </div>
    <div class="save-and-continue" ld--elist="click" ld-on-click="onClickSaveAndContinueNext">
        ${ !this.saveAndContinueNext ? `<span>${ this.continueBtnText }</span>`:`` }
        ${ this.saveAndContinueNext ? `<span>${ this.checkDeviceSettingsBtnText }</span>`:`` } 
        <i class="caret-next"></i>
    </div>
    
</div>`  }